import React, {useState} from 'react'
import {css} from '@emotion/core'
import PlusIcon from '../../images/plus-icon.svg'
import MinusIcon from '../../images/minus-icon.svg'

const AboutValueProp = ({item, themeStyles, index}) => {
    const [expanded, setExpanded] = useState(index === 0)
    const {heading, copy} = item
    return (
        <div
            css={css`
                background: ${themeStyles.about.valuePropBackground};
                border-radius: 24px;
                padding: 20px;
            `}
        >
            <div
                css={css`
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 20px;
                `}
                className="value-prop"
            >
                <div
                    css={css`
                        display: flex;
                        align-items: center;
                        gap: 20px;
                    `}
                >
                    <div
                        css={css`
                            background: ${themeStyles.about.valuePropNumberBackground};
                            width: 32px;
                            height: 32px;
                            min-width: 32px;
                            min-height: 32px;
                            flex-shrink: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 50%;
                            color: ${themeStyles.about.valuePropNumberTextColor};
                            font-size: 20px;
                            font-weight: 700;
                        `}
                    >
                        {index + 1}
                    </div>
                    <h3
                        css={css`
                            color: ${themeStyles.about.valuePropTextColor};
                            font-size: 24px;
                            font-weight: 700;
                            line-height: 32px;
                            letter-spacing: -0.48px;
                            @media (${themeStyles.breakPoints.mobile}) {
                                font-size: 18px;
                                line-height: 28px;
                                letter-spacing: -0.36px;
                            }
                        `}
                    >
                        {heading}
                    </h3>
                </div>
                {!expanded && (
                    <PlusIcon
                        css={css`
                            cursor: pointer;
                            width: 16px;
                            min-width: 16px;
                            color: ${themeStyles.about.valuePropTextColor};
                            path {
                                color: ${themeStyles.about.valuePropTextColor};
                            }
                        `}
                        onClick={() => setExpanded(true)}
                    />
                )}
                {expanded && (
                    <MinusIcon
                        css={css`
                            cursor: pointer;
                            width: 16px;
                            min-width: 16px;
                            color: ${themeStyles.about.valuePropTextColor};
                            path {
                                color: ${themeStyles.about.valuePropTextColor};
                            }
                        `}
                        onClick={() => setExpanded(false)}
                    />
                )}
            </div>
            {expanded && (
                <div
                    css={css`
                        margin: 20px 0 0 52px;
                        padding-right: 70px;
                    `}
                >
                    <p
                        css={css`
                            font-size: 18px;
                            line-height: 28px;
                            color: ${themeStyles.about.valuePropTextColor};
                            @media (${themeStyles.breakPoints.mobile}) {
                                font-size: 16px;
                                line-height: 24px;
                            }
                        `}
                    >
                        {copy}
                    </p>
                </div>
            )}
        </div>
    )
}

export default AboutValueProp
